import { StepsToInvestArr } from '../../singleFund/singleFundConst';
import amcStyles from '../../../styles/amcs.scss';
import { Arrow } from './arrow';
import { Steps } from './steps';

export const StepsToInvest = () => {
  return (
    <div className={amcStyles['bg-lightsky']}>
      <section className="lil-container lil-flex lil-flex-wrap lil-pt-24  md:lil-pt-6 sm:lil-pt-12 sm:lil-pb-0">
        <div className="lil-w-1/2 md:lil-w-full sm:lil-w-full">
          <h3 className="lil-pr-4">
            3 easy steps to complete your investment{' '}
          </h3>
          <div className="lil-flex lil-pt-6 lil-items-center sm:lil-items-start">
            <p className=" sm:lil-w-5/6 lil-w-9/12">
              Complete the entire investment process in just three simple steps
              and enjoy your returns.
            </p>
          </div>
          <div className="lil-pt-4 lil-flex lil-flex-wrap">
            <button
              className="lil-btn lil-btn-link lil-px-0"
              onClick={() => {
                window.scrollTo(0, 0);
              }}
            >
              Invest Now
              <span className="lil-font-medium lil-inline-block">&nbsp; →</span>
            </button>
          </div>
        </div>
        <div className="lil-w-1/2 md:lil-w-full lil-pl-6 sm:lil-w-full sm:lil-pl-0 sm:lil-pt-6">
          <div className="lil-pt-0 lil-p-4">
            {StepsToInvestArr.map(ele =>
              ele.arrow ? <Arrow /> : <Steps {...ele} />
            )}
          </div>
        </div>
      </section>
    </div>
  );
};



// WEBPACK FOOTER //
// ./components/singleFundNewCmp/stepsToInvest/index.tsx